'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = withTheme;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _Context = require('./Context');

var _Context2 = _interopRequireDefault(_Context);

var _isReact = require('is-react');

var _isReact2 = _interopRequireDefault(_isReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function withTheme(Component) {
  var WrappedComponent = _react2.default.forwardRef(function (props, _ref) {
    var context = _react2.default.useContext(_Context2.default);
    var ref = _isReact2.default.classComponent(Component) ? _ref : undefined;

    return _react2.default.createElement(Component, (0, _extends3.default)({ ref: ref }, props, context));
  });

  WrappedComponent.displayName = 'WithTheme(' + (Component.displayName || 'Anonymous') + ')';

  return (0, _hoistNonReactStatics2.default)(WrappedComponent, Component);
}